import {CONSTANTS} from "../constants/constants"
import {getVideoByFFmpeg} from "../utils/getVideoByFFmpegUtils"
import {useCropper} from "./useCropper"

interface UseVideoProcessingProps {
    materialIndex: number
}

export const useVideoProcessing = ({
    materialIndex,
}: UseVideoProcessingProps) => {
    const cropper = useCropper(materialIndex)

    const downloadProcessedVideo = (downloadUrl: string) => {
        const fullUrl = downloadUrl.startsWith("http")
            ? downloadUrl
            : `https://backend.mckp.live${downloadUrl}`

        const link = document.createElement("a")
        link.href = fullUrl
        link.download = "processed-video.mp4"
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }

    const processVideo = async () => {
        if (
            !cropper ||
            cropper.imageState.status !== "loaded" ||
            !cropper.imageState.videoUrl ||
            !cropper.cropParams
        )
            return

        cropper.setIsProcessing(true)
        cropper.setUploadProgress(0)

        try {
            const response = await fetch(cropper.imageState.videoUrl)
            const blob = await response.blob()
            const file = new File([blob], "video.mp4", {type: "video/mp4"})

            const url = await getVideoByFFmpeg(
                file,
                cropper.cropParams,
                0,
                cropper.imageState.videoDuration,
                CONSTANTS.VIDEO_PROCESSING_API,
                (progress) => cropper.setUploadProgress(progress)
            )

            cropper.setDownloadUrl(url)

            if (url) {
                downloadProcessedVideo(url)
            }
        } catch (error) {
            console.error("Error processing video:", error)
        } finally {
            cropper.setIsProcessing(false)
        }
    }

    return {
        processVideo,
        downloadProcessedVideo,
    }
}
